import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { googleLogin } from "../redux/authSlice";

const GSI_SRC = "https://accounts.google.com/gsi/client";
const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

let gsiPromise;
const loadGsi = () => {
  if (window.google?.accounts?.id) return Promise.resolve();
  if (!gsiPromise) {
    gsiPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = GSI_SRC;
      script.async = true;
      script.defer = true;
      script.onload = resolve;
      script.onerror = () => { gsiPromise = null; reject(); };
      document.head.appendChild(script);
    });
  }
  return gsiPromise;
};

// Google sign-in for customers only — admin accounts are rejected by the backend
const GoogleLoginButton = ({ onError, text = "signin_with" }) => {
  const btnRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const onErrorRef = useRef(onError);
  onErrorRef.current = onError;

  useEffect(() => {
    if (!CLIENT_ID) return;
    let cancelled = false;

    const handleCredential = async ({ credential }) => {
      onErrorRef.current?.("");
      try {
        await dispatch(googleLogin(credential)).unwrap();
        navigate("/");
      } catch (err) {
        onErrorRef.current?.(
          err?.status === 403
            ? "تسجيل الدخول بجوجل غير متاح لحسابات المسؤولين. استخدم البريد الإلكترونى وكلمة المرور."
            : "فشل تسجيل الدخول بجوجل. حاول مجدداً."
        );
      }
    };

    loadGsi()
      .then(() => {
        if (cancelled || !btnRef.current) return;
        window.google.accounts.id.initialize({
          client_id: CLIENT_ID,
          callback: handleCredential,
        });
        window.google.accounts.id.renderButton(btnRef.current, {
          theme: "outline",
          size: "large",
          shape: "pill",
          text,
          locale: "ar",
          width: Math.min(btnRef.current.offsetWidth || 320, 400),
        });
      })
      .catch(() => onErrorRef.current?.("تعذر تحميل تسجيل الدخول بجوجل."));

    return () => { cancelled = true; };
  }, [dispatch, navigate, text]);

  if (!CLIENT_ID) return null;

  return <div ref={btnRef} style={{ width: "100%", display: "flex", justifyContent: "center" }} />;
};

export default GoogleLoginButton;
